module.exports = __webpack_public_path__ + "static/img/2.393aa8f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/11/eng/2.png
// module id = g8H8
// module chunks = 0